import { BadgeCheck, CircleDot } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";

export const Bio = ({ t }) => (
  <section id="chi-sono" className="bg-[#FAF9F5] py-24 sm:py-32" data-testid="bio-section">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
      <div>
        <Reveal>
          <Eyebrow>{t.bio.eyebrow}</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-normal leading-tight tracking-tight text-[#1E2721] sm:text-4xl lg:text-5xl">
            {t.bio.title}
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-8 space-y-5 text-base leading-relaxed text-[#4A554D]">
          <p>{t.bio.p1}</p>
          <p>{t.bio.p2}</p>
        </Reveal>

        <Reveal delay={0.15} className="mt-9 flex flex-wrap gap-3">
          <span className="inline-flex items-center gap-2.5 rounded-2xl border border-[#4D6354]/15 bg-[#EFECE6] px-4 py-3">
            <BadgeCheck size={18} className="shrink-0 text-[#C49A5A]" />
            <span>
              <span className="block text-sm font-semibold text-[#1E2721]">{t.bio.badgeRoi}</span>
              <span className="block text-xs text-[#556B5C]">{t.bio.badgeRoiSub}</span>
            </span>
          </span>
          <span className="inline-flex items-center gap-2.5 rounded-2xl border border-[#4D6354]/15 bg-[#EFECE6] px-4 py-3">
            <BadgeCheck size={18} className="shrink-0 text-[#C49A5A]" />
            <span>
              <span className="block text-sm font-semibold text-[#1E2721]">{t.bio.badgeTsrm}</span>
              <span className="block text-xs text-[#556B5C]">{t.bio.badgeTsrmSub}</span>
            </span>
          </span>
        </Reveal>
      </div>

      <div className="flex flex-col gap-8">
        <Reveal delay={0.1}>
          <div className="overflow-hidden rounded-[1.5rem] shadow-xl shadow-[#4D6354]/10">
            <img
              src={IMAGES.treatment}
              alt="Sala trattamenti osteopatici"
              data-testid="bio-treatment-photo"
              className="aspect-[16/10] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
              loading="lazy"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="rounded-[1.5rem] bg-[#4D6354] p-7 text-[#E6ECE8] sm:p-9">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C49A5A]">
              {t.bio.pillarsTitle}
            </p>
            <ul className="mt-5 grid gap-3 sm:grid-cols-2">
              {t.bio.pillars.map((p) => (
                <li key={p} className="flex items-center gap-2.5 text-sm">
                  <CircleDot size={11} className="shrink-0 text-[#C49A5A]" />
                  {p}
                </li>
              ))}
            </ul>
            <div className="mt-7 border-t border-[#FAF9F5]/15 pt-5">
              <span className="font-display text-3xl italic text-[#FAF9F5]">{t.bio.since}</span>
              <span className="ml-3 text-xs uppercase tracking-[0.18em] text-[#C9D8CE]">
                {t.bio.sinceSub}
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
